import React, {useState} from 'react';
import {APIProvider, Map, MapCameraChangedEvent} from "@vis.gl/react-google-maps";
import MapViewMarkers from "./MapView.Markers.tsx";
import {CtrInscriptions} from "../../graphql/generated/graphql-main.tsx";
import {cfg} from "../../config.ts";

const {maps_view} = cfg.react;

type Props = {
    listings: CtrInscriptions[];
    searchBar: React.ReactNode;
    toggleGroup: React.ReactNode;
    msgNoResults: React.ReactNode;
}
const PropertiesMapView = (props: Props) => {
    // activity flag indicating the map has been clicked (activated) - used to toggle InfoWindow in markers
    const [mapActivity, setMapActivity] = useState<number>(0);

    return <React.Fragment>

        <div className={"flex flex-wrap md:flex-nowrap justify-between mb-4 space-x-0 md:space-x-4 " +
            "space-y-4 md:space-y-0"}>
            <div className={"w-full justify-start"}>{props.searchBar}</div>
            <div className={"w-full md:w-auto flex justify-end"}>{props.toggleGroup}</div>
        </div>

        {/* only appears if there are no results */}
        {props.msgNoResults}

        {/* always provide specific height to wrapper so map will take up full available height
            - https://visgl.github.io/react-google-maps/docs/api-reference/components/map */}
        <section className={"h-[800px]"}>
            <APIProvider apiKey={maps_view.api_key}>
                <Map
                    mapId={maps_view.map_id}
                    // montreal GPS coordinates
                    defaultCenter={maps_view.center}
                    defaultZoom={maps_view.default_zoom} // 12
                    // greedy: force scroll-to-zoom w/o use of Ctrl (different settings for zoom interactions)
                    gestureHandling={"greedy"}
                    // when map is clicked, hide any InfoWindow (sort of 'click-outside' event handler)
                    onClick={() => setMapActivity(Date.now())}
                    onCameraChanged={(ev: MapCameraChangedEvent) => {
                        // console.info(`camera.changed: `, ev.detail.center, `zoom`, ev.detail.zoom);
                    }}
                >
                    <MapViewMarkers
                        mapActivityFlag={mapActivity}
                        listings={props.listings}
                    ></MapViewMarkers>
                </Map>
            </APIProvider>
        </section>
    </React.Fragment>
}
export default PropertiesMapView;
